import { render, staticRenderFns } from "./UVPrinting.vue?vue&type=template&id=87bedf90&scoped=true"
import script from "./UVPrinting.vue?vue&type=script&lang=js"
export * from "./UVPrinting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bedf90",
  null
  
)

export default component.exports